import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";

const faqs = [
  {
    q: "Comment se passe l'intervention ?",
    a: "Vous nous contactez, nous établissons un devis gratuit. Nos équipes viennent sur site, prennent en charge toute la manutention (descente, chargement), transportent vos archives dans notre centre agréé où elles sont broyées. Un certificat de destruction vous est ensuite remis.",
  },
  {
    q: "Fournissez-vous un certificat de destruction ?",
    a: "Oui, systématiquement après chaque intervention. Preuve légale conforme RGPD, archivable pour vos audits.",
  },
  {
    q: "Étages sans ascenseur, caves, sous-sols : vous gérez ?",
    a: "Absolument, c'est notre spécialité. Nous descendons vos archives depuis n'importe quel étage, cave, sous-sol ou local à accès difficile. Vous n'avez rien à porter.",
  },
  {
    q: "Quel est le délai d'intervention ?",
    a: "Délai moyen : 24 à 48 heures après acceptation du devis. Pour les urgences, nous nous adaptons.",
  },
  {
    q: "Faites-vous vraiment toute la manutention ?",
    a: "Oui, c'est le cœur de notre service. Emballage, étiquetage, descente, chargement, transport. Vos équipes ne touchent à rien.",
  },
  {
    q: "Quel volume minimum pour une intervention ?",
    a: "Pas de volume minimum strict. Quelques cartons ou plusieurs palettes : nous nous déplaçons. Le devis s'adapte à votre situation.",
  },
];

export default function FAQ() {
  return (
    <section
      id="faq"
      className="py-20 md:py-32 bg-white"
      data-testid="faq-section"
    >
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center">
          <div className="text-xs sm:text-sm font-bold uppercase tracking-[0.2em] text-blue-600">
            FAQ
          </div>
          <h2 className="font-display mt-3 text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight text-slate-950" data-testid="faq-title">
            Questions fréquentes.
          </h2>
        </div>

        <div className="mt-10 md:mt-12">
          <Accordion type="single" collapsible className="space-y-3" data-testid="faq-accordion">
            {faqs.map((f, i) => (
              <AccordionItem
                key={i}
                value={`item-${i}`}
                className="border border-slate-200 rounded-2xl px-5 bg-white hover:border-slate-300 transition-colors data-[state=open]:border-blue-300 data-[state=open]:bg-blue-50/40"
                data-testid={`faq-item-${i}`}
              >
                <AccordionTrigger className="text-left font-display font-bold text-base sm:text-lg text-slate-950 hover:no-underline py-5">
                  {f.q}
                </AccordionTrigger>
                <AccordionContent className="text-slate-600 leading-relaxed text-base pb-5">
                  {f.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>
      </div>
    </section>
  );
}
